define('models/WidgetGroupModel',['underscore','LocalStorage','ObjectModel','app','UrlFactory','models/WidgetCollectionCollection'],function (_,LocalStorage,ObjectModel,app,UrlFactory,WidgetCollectionCollection) {
    //
    // Model WidgetGroup
    //
    var WidgetGroupModelPrototype = {

        name:'WidgetGroupModel',
        route:'apiWidgetGroupModel',
        idAttribute:'id_widget_group',

        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
            if(!this.get(this.idAttribute)){
                this.attributes[this.idAttribute] = this.get('id');
            }
        },
        //
        getCollections:function(){
            // retourne le tableau de toutes les collections du groupe
            var group = this,
                collections = group.collections;
            if(!collections){
                // fabrique la collection une seule fois, lors de la première demande
                collections = new WidgetCollectionCollection();
                _(group.get('collection')).each(function(id_widget_collection){
                    collections.add(app.getWidgetCollection(id_widget_collection));
                });
                group.collections = collections;
            }
            return collections;

        },
        // récupère la Widget Collection la plus pertitante du groupe
        getContextualCollection:function(){
            //
            var group = this,
                oneMatch = 0,
                sorted = group.getCollections().sortBy(function(widgetCollection){
                var matchTarget = widgetCollection.matchTarget(), // 0|1|2
                    matchDate = widgetCollection.matchDatetime() ? 1:0, // 0|1
                    matchScore = matchDate * matchTarget;
                oneMatch += matchScore;
                //
                return - matchScore;
            });
            //
            return oneMatch > 0 ?
                sorted[0] :
                app.getWidgetCollection(group.get('default_collection')); // par défaut, on a toujours un id default_collection
        },
        getUrl:function(){
            return UrlFactory.getUrl('widgetGroup',{widget_group_rewrite:this.get('link_rewrite')});
        },
        isPage:function(){
            return this.get('is_page') === '1';
        },
        useJs:function(){
            return this.get('use_js');
        }
    };

    var WidgetGroupModel = ObjectModel.extend(LocalStorage).extend(WidgetGroupModelPrototype);

    return WidgetGroupModel;
});
